import React from 'react';
import SignupForm from './components/SignupForm';
import { useHistory } from 'react-router-dom';
import AuthFormPage from './components/AuthFormPage';

const SignUpPage = () => {
  const history = useHistory();
  const signup = (email) => {
    history.push('/signup/confirm', {email});
  };
  return (
    <AuthFormPage title="Clickability Signup">
      <SignupForm
        onComplete={signup}
        title="Create your Clickability account"
        loginLink="/login"
        socialLogin={true}
      />
    </AuthFormPage>
  );
};

export default SignUpPage;
